import React from 'react';
import PerSurfParagraphList from './PerSurfParagraphList';
import webapi from '../../../api/webapi';
import EmptyDiv from '../Footer/EmptyDIV';
import Loading from '../modal/Loading';

class PerSurfVersionSelectBar extends React.Component{
    
    state = { SelectedBookVersion: '' };
    state = { modalshow: false };

    componentDidMount() {
        this.setState({ SelectedBookVersion : '' });   
    }

    async GetData() {
        this.setState({loadingShow:true})
        //console.log('persiansurf/paragraph/'+this.props.SelectedBook+'/'+this.props.SelectedChapter+'/'+this.state.SelectedBookVersion)
        await webapi.get('persiansurf/paragraph/'+this.props.SelectedBook+'/'+this.props.SelectedChapter+'/'+this.state.SelectedBookVersion)
            .then(response => {
                this.setState({ ParagraphList : response.data },()=>{});
            }) 
        this.setState({loadingShow:false})
    }

    async UpdateBookVersionList(){
        this.setState({loadingShow:true})
        this.setState({ ParagraphList : '' })
        await webapi.get('persiansurf/bookversionbook/'+this.state.SelectedBook)
            .then(response => {
                this.setState({ BookVersionList: response.data},()=>{});
            })
        //if  (this.state.BookVersionList.length===1)
        //{   
            this.setState({ SelectedBookVersion : this.state.BookVersionList[0].Code })
        // }
        // else
        //     if  (this.state.BookVersionList.length>1)
        //     {
        //         this.setState({ SelectedBookVersion : 'All' })
        //     }
        this.setState({loadingShow:false})
    }

    componentDidUpdate() {
        if ((this.props.SelectedBook)&&(this.props.SelectedChapter)&&(this.props.SelectedChapter!==this.state.SelectedChapter))
        {
            this.setState({ SelectedBook : this.props.SelectedBook },()=>{});
            this.setState({ SelectedChapter : this.props.SelectedChapter },()=>{this.UpdateBookVersionList();});
        }
     }
     
    onSearchButtonClick = event =>{
        event.preventDefault();
        this.setState({ ParagraphList : '' })
        this.GetData(); 
    }

    onTextChange = event=> {
        this.setState({ SelectedBookVersion : event.target.value });
        this.setState({ ParagraphList : '' })
    }

    onTextKeyPress = event => {
        if ((event.nativeEvent.key === "Enter")&&(this.state.SelectedBookVersion)) {
            event.preventDefault();
            this.onSearchButtonClick(event);
        }
    }
    render(){
        return (
            [
                <div className="SearchBar" style={{margin:'0px auto 0px auto',width:'100%'}}>
                    <form>
                        <div className="divSearch">
                            <div className="fullwidth_div">
                                <label style={{width:'calc(50% - 30px)',margin:'0px',marginRight: '25%',marginTop: '15px', float: 'right'}}>{this.props.Label}</label>
                                <select style={{width:'calc(50% - 30px)',direction:'inherit',margin:'0px 15px',marginRight: '25%',marginTop: '15px', float: 'right'}}
                                    id="SelectedBookVersion" 
                                    type="text" 
                                    className=""
                                    required="required" 
                                    value={this.state.SelectedBookVersion || ''} 
                                    onChange={this.onTextChange}
                                    onKeyPress={this.onTextKeyPress}
                                >  
                                    {   
                                        ((this.state.BookVersionList)&&(this.state.BookVersionList != null))
                                        ?
                                        (this.state.BookVersionList.map((BookVersion,i) =>
                                            {
                                                return  (
                                                    (i===0)
                                                    ?
                                                    (
                                                        //[
                                                          //  <option key={BookVersion.Code+"-1"} value={"All"} select="true">{this.props.pageData.length!==0 && this.props.pageData[0].F89902!== undefined?this.props.pageData[0].F89902:89902/*همه*/}</option>
                                                            //,
                                                            <option key={BookVersion.Code} value={BookVersion.Code}>{BookVersion.Title}</option> 
                                                        //]
                                                    )
                                                    :
                                                    (
                                                        <option key={BookVersion.Code} value={BookVersion.Code}>{BookVersion.Title}</option> 
                                                    )
                                                )
                                            })
                                        )
                                        :
                                        <option value="p-1">-</option>       
                                    }                
                                </select>
                            </div>
                            
                            <input className="submit_button" type="submit" value={this.props.pageData.length!==0 && this.props.pageData[0].F89901!== undefined?this.props.pageData[0].F89901:89901/*"جستجو"*/} onClick={this.onSearchButtonClick} />
                        </div>
                    </form>
                </div>
                ,
                (this.state.ParagraphList && this.state.ParagraphList.length>0)
                ?
                <PerSurfParagraphList   SelectedBookVersion={this.state.SelectedBookVersion}
                                        ParagraphList={this.state.ParagraphList}
                                        pageData={this.props.pageData}
                />
                :
                <EmptyDiv />
                ,
                <Loading loadingShow={this.state.loadingShow} />
            ]
        );
    }
}

export default PerSurfVersionSelectBar;